import PropertyRegistryABI from "../contracts/PropertyRegistry.json";

export const propertyRegistryConfig = {
  address: "0x1bdf2502e00a2a08cfa931c3890525c32f81296d",
  abi: PropertyRegistryABI,
  network: "testnet"
};
